import {
  ParentAccount,
  WireGuardFilterState,
  WireGuardTunnel,
} from "./wireGuardTunnelsInterfaces";
import { getComputedTunnelStatus } from "./wireGuardTunnelStatusUtils";

export const applyWireGuardFilters = (
  tunnels: WireGuardTunnel[],
  filters: WireGuardFilterState,
  parentAccounts: ParentAccount[]
) => {
  const parentGroupNameById = new Map<number, string>();
  parentAccounts.forEach((parent) => {
    parentGroupNameById.set(parent.id, parent.name);
  });

  const searchLower = filters.searchText.trim().toLowerCase();

  return tunnels.filter((tunnel) => {
    const tunnelStatus = getComputedTunnelStatus(tunnel.last_handshake);

    if (
      filters.groupIds.length > 0 &&
      (tunnel.group === null || !filters.groupIds.includes(tunnel.group))
    ) {
      return false;
    }

    if (
      filters.serverIds.length > 0 &&
      (tunnel.server === null || !filters.serverIds.includes(tunnel.server))
    ) {
      return false;
    }

    if (
      filters.tunnelStatuses.length > 0 &&
      !filters.tunnelStatuses.includes(tunnelStatus)
    ) {
      return false;
    }

    if (
      filters.subnetVirtuallyAssigned === "yes" &&
      !tunnel.subnets_are_virtually_assigned
    ) {
      return false;
    }

    if (
      filters.subnetVirtuallyAssigned === "no" &&
      tunnel.subnets_are_virtually_assigned
    ) {
      return false;
    }

    if (!searchLower) {
      return true;
    }

    const haystack = [
      tunnel.name,
      tunnel.client_tunnel_ip,
      tunnel.client_public_key,
      tunnel.subnets?.join(" ") ?? "",
      tunnelStatus,
      tunnel.group ? parentGroupNameById.get(tunnel.group) ?? "" : "",
    ]
      .join(" ")
      .toLowerCase();

    return haystack.includes(searchLower);
  });
};
